/**
 * Entity types for audit logging
 * Mirrors backend constants from portal-api/src/modules/audit/constants/audit-entity-types.constants.ts
 */
export const AUDIT_ENTITY_TYPES = {
  EMAIL_SOLICITATION: "EMAIL_SOLICITATION",
  EMAIL_SOLICITATION_DIVERGENCE: "EMAIL_SOLICITATION_DIVERGENCE",
  EMAIL_SOLICITATION_NSU: "EMAIL_SOLICITATION_NSU",
  DIVERGENCE: "DIVERGENCE",
  NSU: "NSU",
  STORE_CONCILIATION: "STORE_CONCILIATION",
} as const;

/**
 * Action types for audit logging
 */
export const AUDIT_ACTION_TYPES = {
  STORE_UPLOADED_FILES: "STORE_UPLOADED_FILES",
  STORE_FINALIZED_CONCILIATION: "STORE_FINALIZED_CONCILIATION",
  STORE_SUBMITTED_JUSTIFICATION: "STORE_SUBMITTED_JUSTIFICATION",
  STORE_OPENED_EMAIL: "STORE_OPENED_EMAIL",
  ANALYST_REJECTED_EVIDENCE: "ANALYST_REJECTED_EVIDENCE",
  ANALYST_APPROVED_EVIDENCE: "ANALYST_APPROVED_EVIDENCE",
  ANALYST_UPDATED_STATUS: "ANALYST_UPDATED_STATUS",
  EMAIL_SENT: "EMAIL_SENT",
  EMAIL_RESENT: "EMAIL_RESENT",
} as const;

/**
 * Event types for audit logging
 */
export const AUDIT_EVENT_TYPES = {
  STATUS_CHANGE: "STATUS_CHANGE",
  FIELD_UPDATE: "FIELD_UPDATE",
  ACTION_EXECUTED: "ACTION_EXECUTED",
} as const;

export type AuditEntityType = (typeof AUDIT_ENTITY_TYPES)[keyof typeof AUDIT_ENTITY_TYPES];
export type AuditActionType = (typeof AUDIT_ACTION_TYPES)[keyof typeof AUDIT_ACTION_TYPES];
export type AuditEventType = (typeof AUDIT_EVENT_TYPES)[keyof typeof AUDIT_EVENT_TYPES];
